import { useState } from "react";
import {
  Box,
  Divider,
  IconButton,
  ListItemText,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { AccountCircle } from "@material-ui/icons";
import CachedIcon from "@material-ui/icons/Cached";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth } from "../../contexts/authContext";
import { RootState } from "../../redux/store";

const useStyles = makeStyles((theme) => ({
  userMenu: {
    fontFamily: "'Inter', 'Sailec', Arial, sans-serif !important",
    "& .MuiMenuItem-root": {
        fontFamily: "'Inter', 'Sailec', Arial, sans-serif !important",
    },
    "& .MuiTypography-body1": {
        fontFamily: "'Inter', 'Sailec', Arial, sans-serif !important",
    },
    "& .MuiTypography-subtitle1": {
        fontFamily: "'Inter', 'Sailec', Arial, sans-serif !important",
    },
  },
  userMenuText: {
    marginLeft: theme.spacing(1),
  },
  userDetailText: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        minWidth: 0,
        maxWidth: "250px",
        whiteSpace: "nowrap",
        lineHeight: "1.2 !important"
  },
  menuIcon: {
        marginRight: theme.spacing(1.2),
  },
  menuIconSmall: {
      height: "21px",
      width: "21px",
      marginRight: theme.spacing(1.5),
  },
  userAvatar: {
      height: "40px",
      width: "40px",
      borderRadius: "100%",
  },
  userAvatarMenuIcon: {
      display: "flex",
      alignItems: "center",
  },
  userNameText: {
    fontWeight: "bold"
  }
}));

const logoutSVG = `${process.env.PUBLIC_URL}/images/logout.svg`;

function UserMenu() {
  const classes = useStyles();
  const history = useHistory();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const open = Boolean(menuAnchorEl);
  const { rootAccounts } = useSelector((state: RootState) => state.account);
  const { user, logout } = useAuth();

  const goToAccountSelect = () => {
    history.push("/account-select");
  };

  const handleMenuToggle = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
  };

  return (
    <>
     
       <IconButton aria-label="User menu" aria-controls="user-menu" aria-haspopup="true" onClick={handleMenuToggle} color="inherit">
          {user?.details.picture ? (
              <img src={user.details.picture} className={classes.userAvatar} alt="" />
          ) : (
              <AccountCircle className={classes.userAvatar} />
          )}
        </IconButton>
      <Menu
        id="user-menu"
        anchorEl={menuAnchorEl}
        getContentAnchorEl={null}
        keepMounted
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={handleCloseMenu}
        onClick={handleCloseMenu}
      >
        <MenuItem>
            <Box className={classes.userAvatarMenuIcon}>
                {user?.details?.picture ? (
                    <img
                        src={user.details.picture}
                        className={`${classes.userAvatar} ${classes.menuIcon}`}
                        alt=""
                    />
                ) : (
                    <AccountCircle className={`${classes.userAvatar} ${classes.menuIcon}`} />
                )}
            </Box>
            <Box className={classes.userDetailText}>
                <Typography
                    variant="body1"
                    component="div"
                    className={classes.userNameText}
                >{`${user?.details.firstName} ${user?.details.lastName}`}</Typography>
                <Typography variant="subtitle2" component="div">{`${user?.details.email}`}</Typography>
            </Box>
        </MenuItem>
        <Divider />
         {rootAccounts.length > 1 && (
          <MenuItem onClick={goToAccountSelect}>
            <CachedIcon fontSize="small" />
            <ListItemText
              className={classes.userMenuText}
              primary="Change Account"
            />
          </MenuItem>
        )}
        <Divider />
        <MenuItem onClick={logout}>
          <img src={logoutSVG} alt="" className={classes.menuIconSmall} />
          <ListItemText className={classes.userMenuText} primary="Logout" />
        </MenuItem>
      </Menu>
    </>
  );
}

export default UserMenu;
